import React from 'react';
import PropTypes from 'prop-types';
import Cards from '../../componentsV2/Admin/Cards';
import HeaderWithBreadcrumbs from '../../componentsV2/Headers/HeaderWithBreadcrumbs';
import { getRoleChecks } from '../../utils/roles';

const breadcrumbLinks = [{ href: '/admin', name: 'Admin' }];

const AdminDashboard = ({ organizationId, currentUserRole }) => {
  const { isManager } = getRoleChecks(currentUserRole);
  return (
    <div className="mx-2.75">
      <header>
        <HeaderWithBreadcrumbs links={breadcrumbLinks} name="admin" label="Admin" size="h-10" />
      </header>
      <div className="flex flex-wrap justify-center">
        <Cards icon="account_green" title="Account" body="Update your name, email, and password." href="admin/account" />
        <Cards icon="organization" title="Organization" body="Update your organization’s name, contact, and description." href={`/admin/organizations/${organizationId}`} />
        {isManager && (<Cards icon="users" title="Users" body="Add a new user to your organization, change user roles, modify existing users’ contact info, and re-send registration invites." href="admin/users" />)}
        <Cards icon="season" title="Seasons" body="Create seasons to report on visits in a way that reflects your outreach season." href="/seasons" />
        <Cards icon="volunteer_activism" title="Items for Distribution" body="Create and manage your list of items that can be distributed during outreach visits. These can be objects (like flyers and masks), services (like wellness checks), or treatments administered (like a vaccination)." href="admin/items_for_distribution" />
        {isManager && (<Cards icon="add_diamond" title="Custom Fields" body="Add your own fields on the Site form, Visit form, and Contact form so that you can track information specific to your organization’s outreach and reporting methods." href="admin/custom_fields" />)}
      </div>
    </div>
  );
};

AdminDashboard.propTypes = {
  organizationId: PropTypes.number.isRequired,
  currentUserRole: PropTypes.string.isRequired,
};

export default AdminDashboard;
